import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { BalanceValueCard } from "./BalanceValueCard";
import { AppColors } from "@/styles/colors";
import "./text-elements.css";
import { AccountData } from "@/pages/accounts/schema/account.schema";
import { formatCurrency } from "@/utils/format-currency";

interface Props {
  accountData?: AccountData;
}

export const AccountBalanceDataCard = ({ accountData }: Props) => {
  const getUnionBalanceColor = (value: number | undefined) => {
    return Number(value ?? 0) >= 0 ? AppColors.RED_ICON : AppColors.GREEN_ICON;
  };

  const getUnionBalanceValue = (value: number | undefined) => {
    return formatCurrency(Math.abs(Number(value ?? 0)));
  };

  return (
    <Flex flexDir="column">
      <Flex
        flexDir="column"
        padding="8px"
        borderRadius="12px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Text className="abdc-main-title">Saldos</Text>
        <Grid templateColumns="repeat(2, 1fr)" gap="6">
          <GridItem>
            <Flex
              flexDir="column"
              css={{
                "@media (max-width: 1350px) and (min-width: 1272px)": {
                  gap: "5px",
                },
                "@media (max-width: 1414px) and (min-width: 1351px)": {
                  gap: "5px",
                },
                "@media (max-width: 1590px) and (min-width: 1415px)": {
                  gap: "8px",
                },
                "@media (max-width: 1696px) and (min-width: 1591px)": {
                  gap: "8px",
                },
                "@media (max-width: 1900px)": {
                  gap: "10px",
                },
                "@media (min-width: 1901px)": {
                  gap: "10px",
                },
              }}
            >
              <Text className="abdc-column-title">Admis</Text>
              <BalanceValueCard
                title="TOTAL"
                value={formatCurrency(accountData?.saldos?.totalAdmis)}
              />
              <BalanceValueCard
                title="VENCIDO"
                value={formatCurrency(accountData?.saldos?.vencidoAdmis)}
              />
              <BalanceValueCard
                title="A VENCER"
                value={formatCurrency(accountData?.saldos?.aVencerAdmis)}
              />
            </Flex>
          </GridItem>
          <GridItem>
            <Flex
              flexDir="column"
              css={{
                "@media (max-width: 1350px) and (min-width: 1272px)": {
                  gap: "5px",
                },
                "@media (max-width: 1414px) and (min-width: 1351px)": {
                  gap: "5px",
                },
                "@media (max-width: 1590px) and (min-width: 1415px)": {
                  gap: "8px",
                },
                "@media (max-width: 1696px) and (min-width: 1591px)": {
                  gap: "8px",
                },
                "@media (max-width: 1900px)": {
                  gap: "10px",
                },
                "@media (min-width: 1901px)": {
                  gap: "10px",
                },
              }}
            >
              <Text className="abdc-column-title">UniON</Text>
              <BalanceValueCard
                title="TOTAL"
                value={getUnionBalanceValue(accountData?.saldos?.total)}
                valueColor={getUnionBalanceColor(accountData?.saldos?.total)}
              />
              <BalanceValueCard
                title="VENCIDO"
                value={getUnionBalanceValue(accountData?.saldos?.vencido)}
                valueColor={getUnionBalanceColor(accountData?.saldos?.vencido)}
              />
              <BalanceValueCard
                title="A VENCER"
                value={getUnionBalanceValue(accountData?.saldos?.aVencer)}
                valueColor={getUnionBalanceColor(accountData?.saldos?.aVencer)}
              />
            </Flex>
          </GridItem>
        </Grid>
      </Flex>
      <Flex flexDir="column" divideY="1px" paddingTop="10px">
        <Text className="abdc-card-title">Estado de cuenta:</Text>
        <Text
          className="abdc-card-value"
          fontWeight={500}
          color={
            accountData?.estado === "Habilitada" ? AppColors.GREEN_ICON : ""
          }
        >
          {accountData?.estado}
        </Text>
      </Flex>
    </Flex>
  );
};
